/** @format */

import {styled} from '@mui/material/styles';
import {Box, Button, Typography} from '@mui/material';

export const Container = styled(Box)(({theme}) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-start',
  padding: theme.spacing(6),
  backgroundColor: theme.palette.semantic_dark?.surface.surface1,
  minWidth: '320px',
  maxWidth: '500px',
}));

export const Header = styled(Box)(({theme}) => ({
  display: 'flex',
  alignItems: 'center',
  marginBottom: theme.spacing(2),
}));

export const IconWrapper = styled(Box)(({theme}) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  color: theme.palette.semantic_dark?.good.main,

  '.MuiSvgIcon-root': {
    fontSize: '38px',
  },
}));

export const Title = styled(Typography)(({theme}) => ({
  fontSize: '32px',
  fontWeight: 500,
  lineHeight: 'normal',
  color: theme.palette.semantic_dark?.good.main,
  marginLeft: theme.spacing(2),
}));

export const Description = styled(Typography)(({theme}) => ({
  fontSize: '16px',
  fontWeight: 400,
  lineHeight: '20px',
  color: theme.palette.semantic_dark?.surface.onSurface,
  marginBottom: theme.spacing(19),
}));

export const CloseButton = styled(Button)(({theme}) => ({
  width: '100%',
  height: '48px',
  backgroundColor: theme.palette.semantic_dark?.good.main,
  color: theme.palette.semantic_dark?.good.on,
  fontSize: '14px',
  fontWeight: 500,
  textTransform: 'none',
  borderRadius: '8px',

  '&:hover': {
    backgroundColor: theme.palette.semantic_dark?.good.hover,
  },
}));
